import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'formatDateMMDDYYYY' })
export class FormatDateMMDDYYYYPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    try {
      let date: moment.Moment;

      // Converted display values are already in the site's timezone.
      // Parse explicitly before ISO detection because the ET suffix contains T.
      if (typeof value === 'string' && /^\d{2}-\d{2}-\d{4} \d{2}:\d{2} [AP]M(?: ET)?$/.test(value)) {
        const hasEasternLabel = value.endsWith(' ET');
        date = moment(hasEasternLabel ? value.slice(0, -3) : value, 'MM-DD-YYYY hh:mm A', true);
        return date.isValid()
          ? `${date.format('MM-DD-YYYY hh:mm A')}${hasEasternLabel ? ' ET' : ''}`
          : '';
      }

      // Handle ISO date strings (e.g., "2025-11-20T04:07:18Z")
      if (typeof value === 'string' && value.includes('T')) {
        date = moment(value);
      }
      // Handle DD-MM-YYYY format (e.g., "18-11-2025")
      else if (typeof value === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
        date = moment(value, 'DD-MM-YYYY');
      }
      // Handle Date objects
      else if (value instanceof Date) {
        date = moment(value);
      }
      // Try to parse as ISO or any other format
      else {
        date = moment(value);
      }

      // Check if date is valid
      if (!date.isValid()) {
        return value;
      }

      // Format as MM dd yyyy (e.g., "11 20 2025")
      return date.format('MM-DD-YYYY hh:mm A');
    } catch (err) {
      console.error('FormatDateMMDDYYYYPipe error:', err, value);
      return value;
    }
  }
}
